
import React, { useEffect, useState } from 'react';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import { Link } from 'react-router-dom';

function Index({dishMenu, setShowDetailProduct, setScreen, setdishs, location}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
  
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
  
      const [image, setImage] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
  
      const {change} = useRefresh();
      const [menus, setMenus] = useState([]);
  
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
      
      useEffect(() => {
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
              } else {
                  // setImage('https://tumenu.online/images/menus/66c78694d1881.jpg');
              }
          });
  
      }, [dataDish]);
  
  
       useEffect(() => {
          menus.map((item) => {
          if (item.id === 56) {
              setDataDesserts(item);
          }
  
          if (item.id === 57) {
              setDataDrinks(item);
          }
          });
      }, [menus]);
  
      
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999, background: 'black'}}>
         
                <div style={{padding: '10px 20px',}}>
                    <img src={image}  onContextMenu={(e) => e.preventDefault()} style={{  width: '100%',
                                height: 408, borderRadius: 10, pointerEvents: 'none', }} />
                    <br />

                    <div style={{
                        marginTop: 5,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    display: 'flex',
                        
                    }}>

                        <div style={{
                            fontFamily: "LondrinaSolidRegular",
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '80%'
                        }}>
                        <p className='shor-text-one' style={{fontSize: 32, color: 'white', fontWeight: "900", textAlign: 'left'}}>
                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                        </p>
                    </div>
                        

                        <div style={{
                            display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginRight: 10,
                    }}>
                        <p style={{ fontSize: 30, color: 'white', fontWeight: "900", fontFamily: "LondrinaSolidRegular", }}>
                            {dataDish.price > 0 &&
                            <> $ {dataDish.price.toFixed(2)}</>
                            }
                        </p>
                    </div>
                    </div>
                    
                    <div>
                        <p
                            lineBreakMode="tail"
                            className='shor-text-five'
                        numberOfLines={5}
                        style={{fontSize: 22, textAlign:'left', color: 'white', fontFamily: "LondrinaSolidLight",}}>
                        {langEng ? 
                                        `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                    : 
                                    `${translateMenu(
                                        i18n.language, 
                                        dataDish.language, 
                                        dataDish.regular_decription, 
                                        'regular_decription'
                                    )}`
                            }
                            
                        </p>
                </div>
                <img
                    style={{
                      width: '80%',
                        height: 28,
                                marginTop: 10,
                                objectFit: 'contain',
                    
                  }}
                  src={require('./assets/divider.png')}
                  alt="Logo"
                  /> 


                   
                    <br/>
                <div style={{position: 'absolute', bottom: 20, left: 0, width: '100%',paddingInline: 20, boxSizing: 'border-box'}}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        
                      
                            
                        }}>
                        <div onClick={()=>[setScreen('listproduct'), setdishs(dataDrinks)]} >
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bebidas.png')}
                            resizeMode={'cover'}
                            style={{
                                width: 330,
                                height: 200,
                                borderRadius: 14,
                              
                                objectFit: 'contain',
                                boderRadius: 20,
                                pointerEvents: 'none',
                            }}
                            />
                        </div>

                    <Link onClick={()=>[setScreen('listproduct'), setdishs(dataDesserts)]}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/postres.png')}
                                resizeMode={'cover'}
                            style={{
                                width: 330,
                                height: 200,
                                borderRadius: 14,
                              
                                objectFit: 'contain',
                                boderRadius: 20,
                                pointerEvents: 'none',
                            }}
                            />
                        </Link>
                    </div>

                    <img
                    style={{
                      width: '100%',
                        height: 180,
                                marginTop: 10,
                                objectFit: 'contain',
                    
                  }}
                  src={require('./assets/delivery.png')}
                  alt="Logo"
                  /> 

                    

                    <br />

                    <div style={{
                        marginBottom: 5,
                        display: 'flex',
                        zIndex: 999,
                        alignSelf: 'center',
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            width: '30%',
                            textAlign: 'center',
                        }}
                        onClick={()=> navDish(-1)}
                        >
                            <div
                                style={{
                                    borderRadius: 5,
                                    justifyContent: 'center',
                                    backgroundColor: '#f0a63d',
                                    padding: 5,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                    background: 'white',
                                    display: 'flex'
                                }}
                            >
                            <div
                                style={{
                                padding: 5,
                                paddingVertical: 5,
                                width: '100%',
                                        alignItems: 'center',
                               
                                    }}>
                                    
                                <img src={require('./assets/left.png')} />
                            
                            </div>
                            </div>
                        </div>

                        <div style={{
                            width: '30%',
                                textAlign: 'center',
                        }}>
                            <div
                                style={{
                                borderRadius: 5,
                                justifyContent: 'center',
                                backgroundColor: '#ff002c',
                                    padding: 5,
                                display: 'flex'
                            }}
                            >
                                <div
                                    onClick={() => {
                                        if (location === 'Home') {
                                            setScreen('home')
                                        } else {
                                            setScreen('listproduct')
                                        }
                                        
                                    }}
                                    style={{
                                    padding: 10,
                                    paddingVertical: 3,
                                    width: '100%',
                                  
                                    textDecoration: 'none'
                                }}>
                                        <p style={{
                                            textAlign: 'center',
                                            color: 'white',
                                            textTransform: 'uppercase',
                                            fontSize: 23,
                                        fontWeight: '900',
                                            fontFamily: "LondrinaSolidRegular",
                                    }}>
                                        {langEng ? " Go Back":  "Ir Atras"}
                                        
                                        </p>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '30%',
                            textAlign: 'center'
                        }}
                            onClick={()=> navDish(1)}
                        >
                            <div
                                style={{
                                borderRadius: 5,
                                    justifyContent: 'center',
                                    backgroundColor: '#f0a63d',
                                    padding: 5,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                    background: 'white',
                                    display: 'flex'
                            }}
                        >
                            <div
                                style={{
                                padding: 5,
                                paddingVertical: 5,
                                width: '100%',
                               
                                        alignItems: 'center',
                               
                                }}>
                                <img src={require('./assets/right.png')} />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
        </div>
    );
}
export default Index;